import { createReducer, on } from '@ngrx/store';
import * as PlaceQueryActions from './actions';
import { CalendarQueryCommand } from 'src/app/modules/shared/models/calendar.action.command';
import { IPlaceQueryCommandState } from './states';

export const initialState: IPlaceQueryCommandState = {
  command: new CalendarQueryCommand(),
  error: null,
};

export const placeQueryCommandReducers = createReducer(
  initialState,
  on(PlaceQueryActions.setQueryCommand, (state, action) => ({
    ...state,
  })),
  on(PlaceQueryActions.setFavoritePlaceBtnId, (state, action) => {
    // clear fav custom dropdown
    if (!action?.favBtnId) {
      return {
        ...state,
        command: {
          ...state.command,
          choice: undefined,
          type: undefined,
        },
      };
    }
    return {
      ...state,
      command: {
        ...state.command,
        // favoritePlaceBtnId: action.favBtnId,
        type: action.favBtnId,
        choice: undefined,
        categoryList: undefined,
        category: null,
        categoryNode: null,
        hasFavoriteCategoryFromUrl: action.hasFavoriteCategoryFromUrl,
        updateURL: action.updateURL
      },
    };
  }),
  on(PlaceQueryActions.setCustomDefaultCategoryList, (state, action) => ({
    ...state,
    command: {
      ...state.command,
      // favoritePlaceBtnId: action.favBtnId,
      categoryList: action.categoryList,
      category: action.categoryName,
      categoryNode: action.categoryNode,
      type: undefined,
      // choice: undefined,
      locations: action.locations
    },
  })),
  on(PlaceQueryActions.setDefaultCategory, (state, action) => ({
    ...state,
    command: {
      ...state.command,
      // favoritePlaceBtnId: action.favBtnId,
      categoryList: undefined,
      category: action.category,
      type: undefined,
      // choice: undefined,
    },
  })),
  on(PlaceQueryActions.setSearchText, (state, action) => ({
    ...state,
    command: {
      ...state.command,
      search: action.search,
      searchFields: action.searchFields,
      // favoritePlaceBtnId: undefined,
      // type: undefined,
      // category: undefined,
      // choice: undefined,
      // categoryList: undefined,
    },
  })),
  on(PlaceQueryActions.setIsChoice, (state, action) => ({
    ...state,
    command: {
      ...state.command,
      choice: action.choice,
      type: undefined,
      // categoryList: undefined,
      // favoritePlaceBtnId: undefined,
    },
  })),
  on(PlaceQueryActions.setLocation, (state, action) => ({
    ...state,
    command: {
      ...state.command,
      // feedId: action.feedId,
      location: action.location,
      locations: null,
    },
  })),
  on(PlaceQueryActions.setLocationGroups, (state, action) => ({
    ...state,
    command: {
      ...state.command,
      locations: action.locations,
      location: null,
    },
  })),
);
